import { useSearchParams } from 'react-router-dom';
import '../css/privacyterm.css'
import '../css/zizaits.css'

function Term() {
    const [searchParams] = useSearchParams();
    const language = searchParams.get('language') || '中文';

    document.body.className = 'policy';

    if (language === '英文') {
        return (
            <div className='zizaits-wrap'>
                <p>
                    Please read the following terms carefully before using 自在听书 / ZIZAITS (hereinafter referred to as "the App").
                    By starting to use the App, you acknowledge that you have read, understood, and agreed to be bound by these terms.
                </p>

                <h3>1. About the App</h3>
                <p>
                    This App is an <strong>offline</strong> novel reading and audiobook tool that provides local book import, reading, and
                    text-to-speech audiobook features. The App itself does not provide any book downloading or distribution service.
                </p>

                <h3>2. User Content and Copyright</h3>
                <ul>
                    <li>The books you import through the App are provided by you, and you warrant that you hold the lawful rights to them or have obtained authorization.</li>
                    <li>The App serves only as a reading tool and does not assume responsibility for the copyright legality of the content you import; liability for content infringement is borne by the content provider.</li>
                    <li>Do not use the App to store or distribute any content that violates laws and regulations or infringes upon the legitimate rights and interests of others.</li>
                    <li>If we are notified that imported content infringes upon others' rights, we will cooperate with the rights holder in handling it in accordance with the law.</li>
                </ul>

                <h3>3. Usage Rules</h3>
                <p>You agree not to use the App in the following ways:</p>
                <ul>
                    <li>Reverse engineering, cracking, decompiling, or attempting to obtain the App's source code;</li>
                    <li>Removing, altering, or obscuring copyright notices, trademarks, or other proprietary markings in the App;</li>
                    <li>Using the App to engage in any illegal activity or activity that infringes upon others' rights;</li>
                    <li>Interfering with or damaging the normal operation of the App or the device it runs on.</li>
                </ul>

                <h3>4. Disclaimer</h3>
                <p>The App is provided "as is". We make reasonable efforts to ensure stable operation, but are not liable for the following:</p>
                <ul>
                    <li>Feature anomalies caused by the device system, permissions, or third-party components (such as the system TTS engine);</li>
                    <li>Losses caused by the loss, damage, or accidental deletion of your local data;</li>
                    <li>Any dispute arising from the legality of the content you import.</li>
                </ul>

                <h3>5. Intellectual Property</h3>
                <p>
                    All code, interface design, icons, text, trademarks, and other materials involved in the App are owned by us or our
                    licensors and are protected by copyright, trademark, and other property laws. You may use the App only as authorized and
                    may not copy, modify, redistribute, or create derivative works from the App without permission.
                </p>

                <h3>6. Changes to the Terms</h3>
                <p>
                    We may update these terms from time to time; the updated terms will be displayed within the App, and continued use will be
                    deemed acceptance of the changes. Where required by law, we will notify you separately of material changes.
                </p>

                <h3>7. Termination of Service</h3>
                <p>
                    We may adjust or discontinue part or all of the App's features based on actual circumstances. To stop using the App, you
                    may simply uninstall it; doing so deletes all your local data.
                </p>

                <h3>8. Miscellaneous</h3>
                <p>
                    The interpretation, validity, and dispute resolution of these terms are governed by the laws of the People's Republic of
                    China. Any dispute shall first be resolved through friendly negotiation; failing that, it shall be submitted to the people's
                    court with jurisdiction where the developer is located.
                </p>

                <h3>9. About Imported Content</h3>
                <p>
                    This App is intended for users to import public-domain books for reading and listening. The App is fully offline; we cannot
                    know or control what users import, and users are solely responsible for the files they import and use.
                </p>

                <h3>10. Contact Us</h3>
                <p>If you have any questions about these terms, please contact us:</p>
                <ul>
                    <li>Email: pengdeshen_2013@qq.com</li>
                    <li>WeChat: yelizibiaoge (or open Profile → Contact Us in the App)</li>
                    <li>Developer: Guangzhou Yelizi Network Technology Co., Ltd.</li>
                </ul>

                <p style={{ marginTop: '20px', fontSize: 14 }}>Last updated: October 10, 2026<br />Effective date: October 10, 2026</p>
            </div>
        );
    }

    if (language === '繁体') {
        return (
            <div className='zizaits-wrap'>
                <p>
                    請你在使用「自在聽書」（以下簡稱「本軟體」）前，仔細閱讀以下條款。一旦你開始使用本軟體，
                    即表示你已閱讀、理解並同意接受本條款的約束。
                </p>

                <h3>一、軟體說明</h3>
                <p>
                    本軟體是一款<strong>離線</strong>的小說閱讀與聽書工具，提供本地書籍匯入、閱讀、文字轉語音聽書等功能。
                    本軟體本身不提供任何書籍內容的下載或分發服務。
                </p>

                <h3>二、使用者內容與版權</h3>
                <ul>
                    <li>你透過本軟體匯入的書籍內容由你自行提供，你應保證對該內容擁有合法的權利或已獲得授權。</li>
                    <li>本軟體僅作為閱讀工具，不對你匯入內容的版權合法性負責；因內容侵權產生的責任由內容提供方承擔。</li>
                    <li>請勿利用本軟體儲存或傳播任何違反法律法規、侵犯他人合法權益的内容。</li>
                    <li>若我們獲悉匯入內容涉嫌侵害他人權利，將依法配合權利人處理。</li>
                </ul>

                <h3>三、使用規範</h3>
                <p>你承諾不會以下列方式使用本軟體：</p>
                <ul>
                    <li>逆向工程、破解、反組譯或試圖取得本軟體原始碼；</li>
                    <li>移除、更改或遮蓋本軟體中的版權聲明、商標或其他權利標記；</li>
                    <li>利用本軟體從事任何違法或侵害他人權益的活動；</li>
                    <li>干擾、破壞本軟體及其所在裝置的正常運作。</li>
                </ul>

                <h3>四、免責聲明</h3>
                <p>本軟體按「現狀」提供，我們盡合理努力保障其穩定運作，但不對下列情形承擔責任：</p>
                <ul>
                    <li>因裝置系統、權限或第三方元件（如系統 TTS 引擎）導致功能異常；</li>
                    <li>你本地資料因裝置遺失、損壞或誤刪造成的損失；</li>
                    <li>因你匯入內容合法性引發的一切糾紛。</li>
                </ul>

                <h3>五、智慧財產權</h3>
                <p>
                    本軟體所涉及的程式碼、介面設計、圖示、文字、商標等資料，其權利歸我們或我們的授權人所有，
                    受著作權、商標權及其他財產權法律保護。你僅可在授權範圍內使用本軟體，未經許可不得複製、修改、二次發布或製作衍生產品。
                </p>

                <h3>六、條款變更</h3>
                <p>
                    我們可能不時更新本條款，更新後的條款將在本軟體內展示，繼續使用即視為接受變更。
                    依法律規定需要另行通知的重大變更，我們會另行告知。
                </p>

                <h3>七、服務終止</h3>
                <p>
                    我們可能根據實際情況調整或中斷本軟體的部分或全部功能。你若不再使用本軟體，直接解除安裝即可，
                    解除安裝後你的全部本地資料將被一併刪除。
                </p>

                <h3>八、其他</h3>
                <p>
                    本條款的解釋、效力及爭議解決均適用中華人民共和國相關法律法規。
                    爭議應先友好協商解決；協商不成的，提交軟體開發者所在地有管轄權的人民法院處理。
                </p>

                <h3>九、關於匯入內容</h3>
                <p>
                    本軟體旨在供使用者匯入公版圖書進行閱讀與聽書。軟體完全不連網，我們無法知曉、也無法主導使用者匯入的內容，
                    使用者應對其匯入與使用的檔案自行承擔相應責任。
                </p>

                <h3>十、聯絡我們</h3>
                <p>如你對上述條款有任何疑問，可透過以下方式與我們聯繫：</p>
                <ul>
                    <li>電子郵件：pengdeshen_2013@qq.com</li>
                    <li>微信：yelizibiaoge（或打開應用「我的 → 聯絡我們」）</li>
                    <li>開發營運主體：廣州野離子網絡科技有限公司</li>
                </ul>

                <p style={{ marginTop: '20px', fontSize: 14 }}>更新日期：2026 年 10 月 10 日<br />生效日期：2026 年 10 月 10 日</p>
            </div>
        );
    }

    return (
        <div className='zizaits-wrap'>
            <p>
                请你在使用「自在听书」（以下简称“本软件”）前，仔细阅读以下条款。一旦你开始使用本软件，
                即表示你已阅读、理解并同意接受本条款的约束。
            </p>

            <h3>一、软件说明</h3>
            <p>
                本软件是一款<strong>离线</strong>的小说阅读与听书工具，提供本地书籍导入、阅读、文本转语音听书等功能。
                本软件本身不提供任何书籍内容的下载或分发服务。
            </p>

            <h3>二、用户内容与版权</h3>
            <ul>
                <li>你通过本软件导入的书籍内容由你自行提供，你应保证对该内容拥有合法的权利或已获得授权。</li>
                <li>本软件仅作为阅读工具，不对您导入内容的版权合法性负责；因内容侵权产生的责任由内容提供方承担。</li>
                <li>请勿利用本软件存储或传播任何违反法律法规、侵犯他人合法权益的内容。</li>
                <li>若我们获悉导入内容涉嫌侵害他人权利，将依法配合权利人处理。</li>
            </ul>

            <h3>三、使用规范</h3>
            <p>你承诺不会以下列方式使用本软件：</p>
            <ul>
                <li>反向工程、破解、反编译或试图获取本软件源代码；</li>
                <li>移除、更改或遮盖本软件中的版权声明、商标或其他权利标记；</li>
                <li>利用本软件从事任何违法或侵害他人权益的活动；</li>
                <li>干扰、破坏本软件及其所在设备的正常运行。</li>
            </ul>

            <h3>四、免责声明</h3>
            <p>本软件按“现状”提供，我们尽合理努力保障其稳定运行，但不对以下情形承担责任：</p>
            <ul>
                <li>因设备系统、权限或第三方组件（如系统 TTS 引擎）导致功能异常；</li>
                <li>你本地数据因设备丢失、损坏或误删造成的损失；</li>
                <li>因你导入内容合法性引发的一切纠纷。</li>
            </ul>

            <h3>五、知识产权</h3>
            <p>
                本软件所涉及的代码、界面设计、图标、文字、商标等资料，其权利归我们或我们的授权人所有，
                受著作权、商标权及其他财产权法律保护。你仅可在授权范围内使用本软件，
                未经许可不得复制、修改、二次发布或制作与本软件有关的衍生产品。
            </p>

            <h3>六、条款变更</h3>
            <p>
                我们可能不时更新本条款，更新后的条款将在本软件内展示，继续使用即视为接受变更。
                依法律规定需要另行通知的重大变更，我们会另行告知。
            </p>

            <h3>七、服务终止</h3>
            <p>
                我们可能根据实际情况调整或中断本软件的部分或全部功能。你若不再使用本软件，直接卸载即可，
                卸载后你的全部本地数据将被一并删除。
            </p>

            <h3>八、其他</h3>
            <p>
                本条款的解释、效力及争议解决均适用中华人民共和国相关法律法规。
                争议应先友好协商解决；协商不成的，提交软件开发商所在地有管辖权的人民法院处理。
            </p>

            <h3>九、关于导入内容</h3>
            <p>
                本软件旨在供用户导入公版图书进行阅读与听书。软件完全不联网，我们无法知晓、也无法主导用户导入的内容，
                用户应对其导入与使用的文件自行承担相应责任。
            </p>

            <h3>十、联系我们</h3>
            <p>如你对上述条款有任何疑问，可通过以下方式与我们联系：</p>
            <ul>
                <li>电子邮箱：pengdeshen_2013@qq.com</li>
                <li>微信：yelizibiaoge（或打开应用「我的 → 联系我们」）</li>
                <li>开发运营主体：广州野离子网络科技有限公司</li>
            </ul>

            <p style={{ marginTop: '20px', fontSize: 14 }}>更新日期：2026年10月10日<br />生效日期：2026年10月10日</p>
        </div>
    );
}

export default Term;
